Object.defineProperty(exports,"__esModule",{value:true});exports.armStateDataForDevice=undefined;

var _securityDeviceArmState=require('./securityDeviceArmState');
var _types=require('./types');
var _moment=require('moment');var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var armStateDataForDevice=exports.armStateDataForDevice=function armStateDataForDevice(securityDevice){
var securityState=(0,_securityDeviceArmState.getSecurityDeviceArmState)(securityDevice);
var device=securityDevice?
securityDevice.getArmDevice():
{
securityStatusUpdatedAt:null};


if(!securityState){
return{
armStateType:_types.armState.MISSING_SECURITY_DEVICE,
armStateTitle:'Missing Security Device',
armStateSince:null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:null,
armStateActionTitleInProgress:null,
armStateAction:null};

}

switch(securityState.type){
case _types.armState.ALARMING:
return{
armStateType:securityState.type,
armStateTitle:'Alarming',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:'Silence',
armStateActionTitleInProgress:'Silencing',
armStateAction:_types.positionAction.SILENCE};

case _types.armState.SILENT_ALARMING:
return{
armStateType:securityState.type,
armStateTitle:'Silent Alarming',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:'Disarm',
armStateActionTitleInProgress:'Disarming',
armStateAction:_types.positionAction.DISARM};

case _types.armState.ARMED:
return{
armStateType:securityState.type,
armStateTitle:'Armed',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:'Disarm',
armStateActionTitleInProgress:'Disarming',
armStateAction:_types.positionAction.DISARM};

case _types.armState.LOCKED:
return{
armStateType:securityState.type,
armStateTitle:'Locked',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:'Unlock',
armStateActionTitleInProgress:'Unlocking',
armStateAction:_types.positionAction.DISARM};

case _types.armState.DISARMED:
return{
armStateType:securityState.type,
armStateTitle:'Disarmed',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:'Arm',
armStateActionTitleInProgress:'Arming',
armStateAction:_types.positionAction.ARM};

case _types.armState.UNLOCKED:
return{
armStateType:securityState.type,
armStateTitle:'Unlocked',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:null,
armStateActionTitleInProgress:null,
armStateAction:null};

case _types.armState.OPEN:
return{
armStateType:securityState.type,
armStateTitle:'Open',
armStateSince:device.securityStatusUpdatedAt?
(0,_moment2.default)(device.securityStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:null,
armStateActionTitleInProgress:null,
armStateAction:null};

case _types.armState.OTHER_STATE:
case _types.armState.MISSING_SECURITY_DEVICE:
default:
return{
armStateType:securityState.type,
armStateTitle:'Unknown',
armStateSince:null,
armStateMessage:null,
armStateReason:null,
armStateActionTitle:null,
armStateActionTitleInProgress:null,
armStateAction:null};}


};